import FloatingToolbar from './floating-toolbar.js';
import Group from './group.js';


if (!BEditor.Toolbar)
{
  BEditor.Toolbar = Toolbar;
  BEditor.ToolbarCounter = 0;
}


export default function Toolbar (tWindow, idMainContainer, toolbarStructPath, args = {})
{
  const setTimeout = BEditor.createRegistrableTimeout();

  this.isObjValid = false;

  let tbCounter = BEditor.ToolbarCounter++;

  tWindow = tWindow || window;

  this.configurateToolbar = configurateToolbar;
  this.editorStarting = editorStarting;
  this.editorStopped = editorStopped;
  this.showToolbar = showToolbar;
  this.hideToolbar = hideToolbar;
  this.stopUnregEditorInstance = stopUnregEditorInstance;
  this.toolbarOnClick = toolbarOnClick;
  this.unload = unload;
  this.isMouseDown = false;
  this.isClick = false;

  const pThis = this;

  let pEditor = null;

  const pToolbar =
  {
    pThis,

    get pToolbarStruct() { return pToolbarStruct; },
    set pToolbarStruct(v) { pToolbarStruct = v; },
    get floatingToolbar() { return floatingToolbar; },

    get tWindow() { return tWindow; },
    set tWindow(v) { tWindow = v; },
    get tDoc() { return tDoc; },
    set tDoc(v) { tDoc = v; },
    get pEditor() { return pEditor; },
    get pToolbarStructName() { return pToolbarStructName; },
    get isToolbarFloating() { return isToolbarFloating; },
    get isLocalToolbar() { return isLocalToolbar; },
    get tbContainer() { return tbContainer; },
    get editorToolbarContainer() { return editorToolbarContainer; },
    get editorToolbarParent() { return editorToolbarParent; },
    get editorInstanceList() { return editorInstanceList; },

    stopUnregEditorInstance
  };

  const isIE = BEditor.browser.isIE,
        isLocalToolbar = args.isLocalToolbar;

  pThis.EditorToolbarReady = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorToolbarReady' });

  let currentToolbarConfigName = '',
      tDoc,
      isToolbarFloating = false,
      floatingToolbar,
      tbMainContainer,
      tbParentContainer,
      tbContainer,
      editorToolbarContainer,
      editorToolbarParent,
      showToolbarTM = null,
      hideToolbarTM = null,
      unregEditorTM = null,
      refreshStateTM = null,
      refreshStateDoTM = null,
      pGroups = {},
      pToolbarStructName,
      pToolbarStruct,
      editorInstanceList = [],
      editorStartingTM = null,
      toolbarOnClickTM = null;

  const toolbarStruct =
  {
    toolbar:
        [
          { attName: 'toolbarSizeHeight', isRequired: false },
          { attName: 'singlePaddingTop', isRequired: false, attDefault: 0 },
          { attName: 'doublePaddingTop', isRequired: false, attDefault: 0 },
          { attName: 'btnFileURL', isRequired: false },
          { attName: 'btnFileWidth', isRequired: false },
          { attName: 'btnFileHeight', isRequired: false },
          { attName: 'btnOverlapping', isRequired: false },
          { attName: 'sepFileURL', isRequired: false },
          { attName: 'sepSizeWidth', isRequired: false },
          { attName: 'sepSizeHeight', isRequired: false },
          { attName: 'sepSizeVertical', isRequired: false },
          { attName: 'visible', isRequired: false, attDefault: true }
        ],

    group:
        [
          { attName: 'name', isRequired: true, isInherit: false },
          { attName: 'position', isRequired: false, isInherit: false },
          { attName: 'btnFileURL', isRequired: false, isInherit: true },
          { attName: 'btnFileWidth', isRequired: false, isInherit: true },
          { attName: 'btnFileHeight', isRequired: false, isInherit: true },
          { attName: 'btnOverlapping', isRequired: false, isInherit: true },
          { attName: 'sepFileURL', isRequired: false, isInherit: true },
          { attName: 'sepSizeWidth', isRequired: false, isInherit: true },
          { attName: 'sepSizeHeight', isRequired: false, isInherit: true },
          { attName: 'dropdownGroup', isRequired: true, isInherit: false, attDefault: false },
          { attName: 'dropdownGroupType', isRequired: false, isInherit: false },
          { attName: 'openerButtonName', isRequired: false, isInherit: false },
          { attName: 'doubleSize', isRequired: true, isInherit: false, attDefault: false },
          { attName: 'parameters', isRequired: false, isInherit: false },
          { attName: 'visible', isRequired: false, isInherit: false, attDefault: true },
          { attName: 'lineBreak', isRequired: false, isInherit: false, attDefault: false }
        ],

    button:
        [
          { attName: 'name', isRequired: true, isInherit: false },
          { attName: 'type', isRequired: true, isInherit: false, attDefault: 'SimpleButton' },
          { attName: 'btnFileURL', isRequired: true, isInherit: true },
          { attName: 'btnFileWidth', isRequired: true, isInherit: true },
          { attName: 'btnFileHeight', isRequired: true, isInherit: true },
          { attName: 'btnIcoFileURL', isRequired: false, isInherit: true, attDefault: null },
          { attName: 'btnCurIcoFileURL', isRequired: false, isInherit: true, attDefault: null },
          { attName: 'btnBgFileURL', isRequired: false, isInherit: true, attDefault: null },
          { attName: 'btnCurBgFileURL', isRequired: false, isInherit: true, attDefault: null },
          { attName: 'btnArrFileURL', isRequired: false, isInherit: true, attDefault: null },
          { attName: 'ddBtnFileURL', isRequired: false, isInherit: true, attDefault: null },
          { attName: 'ddBtnBgFileURL', isRequired: false, isInherit: true, attDefault: null },
          { attName: 'ddBtnCurBgFileURL', isRequired: false, isInherit: true, attDefault: null },
          { attName: 'icoOffsetX', isRequired: false, isInherit: false, attDefault: null },
          { attName: 'doubleSize', isRequired: true, isInherit: true, attDefault: false },
          { attName: 'btnSizeWidth', isRequired: true, isInherit: true },
          { attName: 'btnSizeHeight', isRequired: true, isInherit: true },
          { attName: 'btnIcoUpNormal', isRequired: true, isInherit: true, attDefault: 0 },
          { attName: 'btnIcoUpOver', isRequired: true, isInherit: true, attDefault: 1 },
          { attName: 'btnIcoUpDisable', isRequired: true, isInherit: true, attDefault: 2 },
          { attName: 'btnIcoDownNormal', isRequired: true, isInherit: true, attDefault: 3 },
          { attName: 'btnIcoDownOver', isRequired: true, isInherit: true, attDefault: 4 },
          { attName: 'btnIcoDownDisable', isRequired: true, isInherit: true, attDefault: 5 },
          { attName: 'btnOverlapping', isRequired: false, isInherit: true, attDefault: 0 },
          { attName: 'title', isRequired: true, isInherit: false, attDefault: '' },
          { attName: 'disabledTitle', isRequired: false, isInherit: false, attDefault: null },
          { attName: 'curTitle', isRequired: false, isInherit: false, attDefault: '' },
          { attName: 'command', isRequired: true, isInherit: false },
          { attName: 'includedCommands', isRequired: false, isInherit: false },
          { attName: 'isStackable', isRequired: true, isInherit: false, attDefault: true },
          { attName: 'dropdownGroupType', isRequired: false, isInherit: true },
          { attName: 'openerButtonName', isRequired: false, isInherit: true },
          { attName: 'model', isRequired: false, isInherit: false },
          { attName: 'parameters', isRequired: false, isInherit: false },
          { attName: 'visible', isRequired: false, isInherit: false, attDefault: true },
          { attName: 'state', isRequired: false, isInherit: false, attDefault: 'UpDisable' }
        ]
  };


  init();


  function init ()
  {
    BEditor.Config.Ready.addHandler(createTootlbar);
  }

  function unload ()
  {
    setTimeout.disposeTimeouts();
  }

  function createTootlbar ()
  {
    if (pThis.isObjValid)
    {
      reInitThemeStyles();
      return;
    }

    const toolbarParts = toolbarStructPath.split('.');
    pToolbarStructName = toolbarParts[toolbarParts.length - 1];
    pToolbarStruct = BEditor.environment.topWindow[pToolbarStructName];
    parseToolbarStruct();
    setTimeout(function () { initToolbar(pToolbarStructName); }, 200);
  }


  function parseToolbarStruct ()
  {
    let i,
        coGroups,
        coButtons,
        groupLineSizeWidth = 0,
        isLineBreak = false,
        isDoubleContainer = false,
        singleSizeContainerHeight = 0,
        coLineBreak = 0;

    pToolbarStruct.toolbarSizeWidth = 0;
    pToolbarStruct.singleSizeContainerWidth = 0;
    pToolbarStruct.doubleSizeContainerWidth = 0;

    for (i = 0; i < toolbarStruct.toolbar.length; i++)
    {
      if (!(toolbarStruct.toolbar[i].attName in pToolbarStruct))
      {
        if (toolbarStruct.toolbar[i].attDefault !== undefined)
        {
          pToolbarStruct[toolbarStruct.toolbar[i].attName] = toolbarStruct.toolbar[i].attDefault;
        }
        else if (toolbarStruct.toolbar[i].isRequired)
        {
          alert('...ERROR...\nNo attribute: ' + toolbarStruct.toolbar[i].attName);
        }
      }
    }

    for (coGroups = 0; coGroups < pToolbarStruct.Groups.length; coGroups++)
    {
      for (i = 0; i < toolbarStruct.group.length; i++)
      {
        if (pToolbarStruct.Groups[coGroups][toolbarStruct.group[i].attName] === undefined)
        {
          if (toolbarStruct.group[i].isInherit && pToolbarStruct[toolbarStruct.group[i].attName] !== undefined)
          {
            pToolbarStruct.Groups[coGroups][toolbarStruct.group[i].attName] = pToolbarStruct[toolbarStruct.group[i].attName];
          }
          else if (toolbarStruct.group[i].attDefault !== undefined)
          {
            pToolbarStruct.Groups[coGroups][toolbarStruct.group[i].attName] = toolbarStruct.group[i].attDefault;
          }
          else if (toolbarStruct.group[i].isRequired)
          {
            alert('...ERROR...\nNo attribute: ' + toolbarStruct.group[i].attName + '\nGroup name: ' + pToolbarStruct.Groups[coGroups].groupName);
          }
        }
      }

      pToolbarStruct.Groups[coGroups].groupSizeWidth = 0;

      if (pToolbarStruct.Groups[coGroups].sepSizeWidth && pToolbarStruct.Groups[coGroups].sepSizeHeight)
      {
        pToolbarStruct.Groups[coGroups].groupSizeWidth += pToolbarStruct.Groups[coGroups].sepSizeWidth;
        pToolbarStruct.Groups[coGroups].groupSizeHeight = pToolbarStruct.Groups[coGroups].sepSizeHeight;
      }
      else
      {
        pToolbarStruct.Groups[coGroups].groupSizeHeight = pToolbarStruct.Groups[coGroups].Buttons[0].btnSizeHeight;
      }

      for (coButtons = 0; coButtons < pToolbarStruct.Groups[coGroups].Buttons.length; coButtons++)
      {
        for (i = 0; i < toolbarStruct.button.length; i++)
        {
          if (pToolbarStruct.Groups[coGroups].Buttons[coButtons][toolbarStruct.button[i].attName] === undefined)
          {
            if (toolbarStruct.button[i].isInherit &&
                (pToolbarStruct.Groups[coGroups][toolbarStruct.button[i].attName] !== undefined ||
                    pToolbarStruct[toolbarStruct.button[i].attName] !== undefined))
            {
              if (pToolbarStruct.Groups[coGroups][toolbarStruct.button[i].attName] !== undefined)
              {
                pToolbarStruct.Groups[coGroups].Buttons[coButtons][toolbarStruct.button[i].attName] =
                    (pToolbarStruct.Groups[coGroups][toolbarStruct.button[i].attName] !== undefined) ?
                    pToolbarStruct.Groups[coGroups][toolbarStruct.button[i].attName] :
                    pToolbarStruct[toolbarStruct.button[i].attName];
              }
              else
              {
                pToolbarStruct.Groups[coGroups].Buttons[coButtons][toolbarStruct.button[i].attName] = pToolbarStruct[toolbarStruct.button[i].attName];
              }
            }
            else if (toolbarStruct.button[i].attDefault !== undefined)
            {
              pToolbarStruct.Groups[coGroups].Buttons[coButtons][toolbarStruct.button[i].attName] = toolbarStruct.button[i].attDefault;
            }
            else if (toolbarStruct.button[i].isRequired)
            {
              alert('...ERROR...\nNo attribute: ' + toolbarStruct.button[i].attName + '\nGroup name: ' + pToolbarStruct.Groups[coGroups].name + '\nButton name: ' + pToolbarStruct.Groups[coGroups].Buttons[coButtons].name);
            }
          }
        }

        pToolbarStruct.Groups[coGroups].Buttons[coButtons].btnLeft = pToolbarStruct.Groups[coGroups].groupSizeWidth - pToolbarStruct.Groups[coGroups].Buttons[coButtons].btnOverlapping;
        pToolbarStruct.Groups[coGroups].groupSizeWidth += pToolbarStruct.Groups[coGroups].Buttons[coButtons].btnSizeWidth - pToolbarStruct.Groups[coGroups].Buttons[coButtons].btnOverlapping;
      }

      isDoubleContainer = pToolbarStruct.Groups[coGroups].doubleSize;
      isLineBreak = (pToolbarStruct.Groups[coGroups].lineBreak && !isDoubleContainer);

      if (isLineBreak)
      {
        if (groupLineSizeWidth > pToolbarStruct.singleSizeContainerWidth)
        {
          pToolbarStruct.singleSizeContainerWidth = groupLineSizeWidth;
        }

        isLineBreak = false;
        coLineBreak++;
        groupLineSizeWidth = pToolbarStruct.Groups[coGroups].groupSizeWidth;
      }
      else if (isDoubleContainer)
      {
        pToolbarStruct.doubleSizeContainerWidth += pToolbarStruct.Groups[coGroups].groupSizeWidth;
      }
      else if (!pToolbarStruct.Groups[coGroups].dropdownGroup)
      {
        groupLineSizeWidth += pToolbarStruct.Groups[coGroups].groupSizeWidth;
      }

      if (!isDoubleContainer)
      {
        singleSizeContainerHeight = pToolbarStruct.Groups[coGroups].groupSizeHeight;
      }
    }

    if (groupLineSizeWidth > pToolbarStruct.singleSizeContainerWidth)
    {
      pToolbarStruct.singleSizeContainerWidth = groupLineSizeWidth;
    }

    pToolbarStruct.toolbarSizeWidth = pToolbarStruct.singleSizeContainerWidth + pToolbarStruct.doubleSizeContainerWidth;

    if (pToolbarStruct.toolbarSizeHeight == null)
    {
      pToolbarStruct.toolbarSizeHeight = singleSizeContainerHeight * (coLineBreak + 1) + ((pToolbarStruct.sepSizeVertical) ? pToolbarStruct.sepSizeVertical * coLineBreak : 0);
    }

    pToolbarStruct.singleSizeContainerHeight = singleSizeContainerHeight;
    pToolbarStruct.doubleSizeContainerHeight = pToolbarStruct.toolbarSizeHeight;

  }


  function initToolbar (toolbarStructName)
  {
    let isNotFloatingToolbar = false;

    tDoc = tWindow.document || document;

    const mainContainer = tDoc.getElementById(idMainContainer);

    if (!mainContainer)
    {
      setTimeout(function () { initToolbar(toolbarStructName); }, 100);
      return;
    }

    if (BEditor.environment.pageView.isAdminView && !((tWindow !== BEditor.environment.topWindow || pToolbarStructName === 'EditorPollDescriptionLocalToolbar') && isLocalToolbar))
    {
      tbMainContainer = mainContainer;
      isNotFloatingToolbar = true;
    }
    else
    {
      isToolbarFloating = true;
      editorToolbarContainer = mainContainer;
      editorToolbarParent = editorToolbarContainer.parentNode;
      floatingToolbar = new FloatingToolbar(pToolbar);
      tbMainContainer = floatingToolbar.init(toolbarStructName);
    }

    if (isNotFloatingToolbar)
    {
      tbMainContainer.style.zIndex = BEditor.AdminPanel.ZIndex.EditModeToolBar.ToolBarEditorTd;
    }

    pThis.isObjValid = 1;
    renderToolbar();
    BEditor.domHandlers.addHandler(tbMainContainer, 'click', BEditor.domHandlers.stopEvent);
  }


  function reInitThemeStyles ()
  {
    const buttons =
        [
          { 'name': 'FormattingDropdown', 'func': 'preInitBlockFormattingDropdownButton'},
          { 'name': 'FormattingDropdownPublic', 'func': 'preInitBlockFormattingDropdownButton'},
          { 'name': 'TextFont', 'func': 'preInitTextFontDropdownButton'},
          { 'name': 'TextFontPublic', 'func': 'preInitTextFontDropdownButton'},
          { 'name': 'ForeColor', 'func': 'preInitForeColorDropdownButton'},
          { 'name': 'BackColor', 'func': 'preInitBackColorDropdownButton'}
        ];

    let pButton;

    for (let i = 0; i < buttons.length; i++)
    {
      pButton = pThis.getButtonByName(buttons[i].name);

      if (pButton)
      {
        pButton[buttons[i].func](true);
      }
    }
  }


  function configurateToolbar (toolbarConfig)
  {
    if (toolbarConfig.name !== currentToolbarConfigName)
    {
      currentToolbarConfigName = toolbarConfig.name;

      Group.groupNextLineTop = pToolbarStruct.singlePaddingTop;
      Group.nextGroupCountLeft = 0;
      pToolbarStruct.singleSizeContainerWidth = 0;

      for (let i = 0; i < toolbarConfig.Groups.length; i++)
      {
        pGroups[toolbarConfig.Groups[i].name].configurateGroup(toolbarConfig, i);
      }
    }
  }


  function editorStarting (pEditorInstance)
  {
    if (editorStartingTM) clearTimeout(editorStartingTM);

    if (pEditorInstance && !editorInstanceList.includes(pEditorInstance))
    {
      editorInstanceList.push(pEditorInstance);
    }

    if (tbContainer)
    {
      tbContainer.style.left = '0px';
      tbContainer.style.top = '0px';
    }
    else
    {
      editorStartingTM = setTimeout(editorStarting, 70);
    }
  }


  function showToolbar ()
  {
    if (showToolbarTM)
    {
      clearTimeout(showToolbarTM);
    }

    if (hideToolbarTM)
    {
      clearTimeout(hideToolbarTM);
    }

    if (pThis.isObjValid === 2)
    {
      if (window.isEditorToolbarPublicConfig)
      {
        tbMainContainer.parentNode.style.width = tbMainContainer.parentNode.offsetWidth + 'px';
      }

      tbMainContainer.setAttribute('visibility', 'visible', 0);

      tbMainContainer.style.position = 'relative';
      tbMainContainer.style.width = 'auto';
      tbMainContainer.style.height = 'auto';

      tbParentContainer.style.visibility = 'visible';

      tbContainer.style.width = pToolbarStruct.toolbarSizeWidth + 'px';
      tbContainer.style.height = pToolbarStruct.toolbarSizeHeight + 'px';
      tbContainer.style.visibility = 'visible';

      if (window.isEditorToolbarPublicConfig)
      {
        tbParentContainer.style.width = '517px';

        if (!isIE)
        {
          tbContainer.style.width = '517px';
        }
      }
    }
    else
    {
      showToolbarTM = setTimeout(showToolbar, 100);
    }
  }


  function editorStopped ()
  {
    tbContainer.style.left = '-3700px';
    tbContainer.style.top = '-3700px';
  }


  function hideToolbar ()
  {
    if (showToolbarTM) clearTimeout(showToolbarTM);
    if (hideToolbarTM) clearTimeout(hideToolbarTM);
    if (floatingToolbar && floatingToolbar.floatingToolbarCalculateSizeTM) clearTimeout(floatingToolbar.floatingToolbarCalculateSizeTM);

    if (pThis.isObjValid === 2)
    {
      tbMainContainer.setAttribute('visibility', 'hidden', 0);
      tbMainContainer.style.width = '0px';
      tbMainContainer.style.height = '0px';
      tbMainContainer.style.paddingTop = '0px';
      tbMainContainer.style.paddingLeft = '0px';
      tbMainContainer.style.paddingRight = '0px';
      tbMainContainer.style.paddingBottom = '0px';
      tbMainContainer.style.borderBottomWidth = '0px';

      tbParentContainer.style.visibility = 'hidden';
      tbParentContainer.style.width = '1px';
      tbParentContainer.style.height = '1px';

      tbContainer.style.visibility = 'hidden';
      tbContainer.style.left = '-3700px';
      tbContainer.style.top = '-3700px';
    }
    else
    {
      hideToolbarTM = setTimeout(hideToolbar, 100);
    }
  }


  function renderToolbar ()
  {
    const canUseLocalConfig = tWindow.name === 'contentarea' || ((!!args.isReactComponentEditor) && isLocalToolbar);

    let editModeToolBar,
        toolbarConfig;


    tbParentContainer = tDoc.createElement('DIV');
    tbParentContainer.style.position = 'relative';
    tbParentContainer.style.visibility = 'hidden';
    tbParentContainer.style.width = '1px';
    tbParentContainer.style.height = '1px';
    tbParentContainer.style[(isIE ? 'styleFloat' : 'cssFloat')] = 'left'; //?????????????????
    tbMainContainer.appendChild(tbParentContainer);

    tbContainer = tDoc.createElement('DIV');
    tbContainer.style.position = 'absolute';
    tbContainer.style.visibility = 'hidden';
    tbContainer.style.left = '-3700px';
    tbContainer.style.top = '-3700px';
    tbContainer.style.width = pToolbarStruct.toolbarSizeWidth + 'px';
    tbContainer.style.height = pToolbarStruct.toolbarSizeHeight + 'px';

    if (BEditor.environment.pageView.isAdminView)
    {
      editModeToolBar = document.body.querySelector('.editModeToolBar');

      if (editModeToolBar)
      {
        tbContainer.style.backgroundColor = BEditor.styleHelpers.getElementStyle(editModeToolBar, 'backgroundColor');
      }
    }

    tbParentContainer.appendChild(tbContainer);

    if (window.isEditorToolbarPublicConfig)
    {
      tbParentContainer.style.overflowX = 'hidden';
      tbParentContainer.style.overflowY = 'visible';

      if (!isIE)
      {
        tbContainer.style.overflowX = 'hidden';
        tbContainer.style.overflowY = 'visible';
      }
    }

    for (let i = 0; i < pToolbarStruct.Groups.length; i++)
    {
      pGroups[pToolbarStruct.Groups[i].name] = new Group(pToolbar, pToolbarStruct.Groups[i]);
    }

    if (canUseLocalConfig)
    {
      toolbarConfig = window[
      {
        'EditorEmailLayoutLocalToolbar': 'EditorToolbarEmailLayoutLocalConfig',
        'EditorCardsLocalToolbar': 'EditorToolbarCardsLocalConfig',
        'EditorEventDescriptionLocalToolbar': 'EditorToolbarEventDescriptionLocalConfig',
        'EditorLocalToolbar': 'EditorToolbarLocalConfig',
        'EditorPollDescriptionLocalToolbar': 'EditorToolbarPollDescriptionLocalConfig'
      }[pToolbarStructName]];

      if (!toolbarConfig)
      {
        throw 'Unknown pToolbarStructName: "' + pToolbarStructName + '"';
      }
    }
    else
    {
      toolbarConfig = window.EditorToolbarPrototypeConfig;
    }

    configurateToolbar(toolbarConfig);

    tbContainer.ondragstart = function() { return false; };

    BEditor.domHandlers.addHandlers(
    [
      [
        tbContainer,
        [
          ['mousedown', toolbarOnClick],
          ['mouseup', toolbarOnClick],
          ['click', toolbarOnClick]
        ]
      ]
    ]);

    pThis.isObjValid = 2;
    pThis.EditorToolbarReady.fireHandlers();
  }


  this.regEditorInstance = function (pEditorInstance)
  {
    stopUnregEditorInstance();

    if (pEditor !== pEditorInstance)
    {
      pThis.unregEditorInstanceDo(pEditor);
    }

    pEditor = pEditorInstance;
    configurateToolbar(pEditor.getEditorToolbarConfig());

    for (let nmGroup in pGroups)
    {
      if (pGroups.hasOwnProperty(nmGroup))
      {
        pGroups[nmGroup].regEditorInstance();
      }
    }
  };


  this.unregEditorInstance = function (pEditorInstance)
  {
    stopUnregEditorInstance();
    unregEditorTM = setTimeout(function() { pThis.unregEditorInstanceDo(pEditorInstance); }, 333);
  };


  this.getEditorInstance = function ()
  {
    return pEditor;
  };


  this.unregEditorInstanceDo = function (pEditorInstance)
  {
    if (unregEditorTM) clearTimeout(unregEditorTM);

    pThis.isMouseDown = false;
    BEditor.isWebKitClipboard = false;

    if (pEditor && pEditor.getEditorId() === pEditorInstance.getEditorId())
    {
      pEditor.editorUnreged();
      pEditor = null;

      for (let nmGroup in pGroups)
      {
        if (pGroups.hasOwnProperty(nmGroup))
        {
          pGroups[nmGroup].unregEditorInstance();
        }
      }
    }
  };


  function stopUnregEditorInstance ()
  {
    if (unregEditorTM) clearTimeout(unregEditorTM);
  }


  pThis.refreshState = function (refreshStateCounter)
  {
    if (refreshStateTM) clearTimeout(refreshStateTM);
    if (refreshStateDoTM) clearTimeout(refreshStateDoTM);

    refreshStateDoTM = setTimeout(refreshStateDo, 17);

    if (refreshStateCounter == null)
    {
      refreshStateTM = setTimeout(function() { pThis.refreshState(1); }, 100);
    }
    else if (refreshStateCounter === 1)
    {
      refreshStateTM = setTimeout(function() { pThis.refreshState(2); }, 150);
    }
    else if (refreshStateCounter === 2)
    {
      refreshStateTM = setTimeout(function() { pThis.refreshState(3); }, 250);
    }
  };


  function refreshStateDo ()
  {
    for (let nmGroup in pGroups)
    {
      if (pGroups.hasOwnProperty(nmGroup))
      {
        pGroups[nmGroup].refreshState();
      }
    }
  }


  pThis.refreshStateButton = function (command)
  {
    if (Group.pButtonsCommand[command])
    {
      Group.pButtonsCommand[command].refreshState();
    }
  };


  function closeDropdowns ()
  {
    for (let nmGroup in pGroups)
    {
      if (pGroups.hasOwnProperty(nmGroup))
      {
        pGroups[nmGroup].closeDropdowns();
      }
    }
  }


  this.getButtonByName = function (buttonName)
  {
    let pButton = null;

    for (let nmGroup in pGroups)
    {
      if (pGroups.hasOwnProperty(nmGroup))
      {
        pButton = pGroups[nmGroup].getButtonByName(buttonName);

        if (pButton)
        {
          break;
        }
      }
    }

    return pButton;
  };


  function toolbarOnClick (e)
  {
    pThis.isClick = true;
    if (toolbarOnClickTM) clearTimeout(toolbarOnClickTM);
    toolbarOnClickTM = setTimeout(function () { pThis.isClick = false; }, 500);
  }



}
